import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { AiChatPage } from './pages/AiChatPage';
import { useDirection } from '@/contexts/DirectionContext';

/** Guard: pe export AI e dezactivat — redirect la dashboard. */
const AiImportOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { direction } = useDirection();
  const navigate = useNavigate();

  useEffect(() => {
    if (direction === 'export') {
      navigate('/app/dashboard', { replace: true });
    }
  }, [direction, navigate]);

  if (direction === 'export') {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <>{children}</>;
};

const AiRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AiImportOnly>
            <AiChatPage />
          </AiImportOnly>
        }
      />
    </Routes>
  );
};

export default AiRoutes;